import { Pipe, PipeTransform } from '@angular/core';
import { Utilities } from '../../_utilities/Utilities';

/***
 * // Currently the value will be in Kilometers. To convert KMS into MLS
 */
@Pipe({
  name: 'miles'
})
export class MilePipe implements PipeTransform {

  transform(value: number, decimals?: number, noSuffix?: boolean, convertingValueUnit?: string): string {
    let _value = Number(value);
    let _decimal = decimals != null ? decimals : 2; // Default is 2 decimal places
    let _suffix = noSuffix;
    let _uom;
    if (convertingValueUnit) {
      _uom = convertingValueUnit;
    } else {
      _uom = 'KMS';
    }
    if (_uom === 'KMS') {
      return (_value * 0.62137).toFixed(_decimal) + (noSuffix ? '' : 'mls');
    } else if (_uom === 'MTRS') {
      return (_value * 0.000621371192).toFixed(_decimal) + (noSuffix ? '' : 'mls');
    }

  }

}



@Pipe({
  name: 'miles'
})
export class VehicleHelpMilePipe implements PipeTransform {

  transform(value: number, decimals?: number, noSuffix?: boolean, convertingValueUnit?: string): string {
    let _value = Number(value);
    let _decimal = decimals != null ? decimals : 2; // Default is 2 decimal places
    let _suffix = noSuffix;
    let _uom;
    if (convertingValueUnit) {
      _uom = convertingValueUnit;
    } else {
      _uom = 'KMS';
    }
    if (_uom === 'KMS') {
      return (_value * 0.62137).toFixed(_decimal) + (noSuffix ? '' : 'mls');
    } else if (_uom === 'MTRS') {
      return (_value * 0.000621371192).toFixed(_decimal) + (noSuffix ? '' : 'mls');
    }

  }

}


// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/distance/mile.pipe.ts